const d = async (t, n, o) => {
  const e = decodeURIComponent(t);
  return e ? fetch(n || "https://vodcore.iranlms.ir/client/", {
    method: "POST",
    headers: new Headers({ "content-type": "application/json" }),
    body: JSON.stringify({
      api_version: "1",
      method: "getPlayContentInfo",
      data: {
        play_token: e
      }
    }),
    signal: o
  }).then((a) => a.json()) : Promise.reject("tokenIsEmpty");
};
export {
  d as default
};
